import React, {useState} from 'react';
import camelize from 'camelize';
import {useMuseumFilterState} from "./museumFilterContext";
import {MuseumList} from "./MuseumList";
import {Box} from "@mui/material";
import {MuseumFilterInput} from "../MuseumFilterInput";

const includeFilter = includeIds =>  museum => includeIds.includes(museum.id);

const searchFilter = searchString => museum => Boolean(searchString)
    ? museum.name.toLowerCase().includes(searchString.toLowerCase())
    : true


export const SideSheetContent = () => {
    const {
        museums,
        includeIds,
        checked,
        expanded
    } = useMuseumFilterState();

    const [museumSearch, setMuseumSearch] = useState("");
    const museumList = camelize(
        museums.filter(includeFilter(includeIds))
            .filter(searchFilter(museumSearch))
            .sort((a, b) => a.name.localeCompare(b.name))
    )

    const filterInput = {
        true: (
            <MuseumFilterInput
                museumSearch={museumSearch}
                setMuseumSearch={setMuseumSearch}
            />
        ),
        false: <div/>
    }

    return (
        <Box sx={{width: "100%"}}>
            {filterInput[expanded]}
            <MuseumList
                museums={museumList.filter(museum => checked.includes(museum.id))}
            />

            <MuseumList
                museums={museumList.filter(museum => !checked.includes(museum.id))}
            />
        </Box>
    )
}